import { useOxygen } from '../../../providers/OxygenProvider';
import { Assignee } from '../../../sdk';
import { getAssigneeDisplayNameWithCompanyName } from '../../../helpers';
import { InlineLoader, LoaderStyle } from '../../InlineLoader';

export type ToolTipContentProps = {
  assignees: Assignee[];
  isTargetRfi?: boolean;
};

export const ToolTipContent = ({ assignees, isTargetRfi = false }: ToolTipContentProps) => {
  const oxygen = useOxygen();

  if (oxygen.loading) {
    return <InlineLoader loaderStyle={LoaderStyle.Spinny} />;
  }

  return (
    <div data-testid="assignee-tooltip-content">
      {assignees.map((assignee) => {
        const displayName = getAssigneeDisplayNameWithCompanyName({
          oxygen,
          assignee,
          isTargetRfi,
        });
        return <div key={assignee.id}>{displayName}</div>;
      })}
    </div>
  );
};
